import { selectSessionState } from '../index';
import { SessionState } from '../reducers/session.reducer';
import { createSelector } from '@ngrx/store';

export const selectAuthUserUid = createSelector(selectSessionState, (state: SessionState) => state.uid);
export const selectAuthUserToken = createSelector(selectSessionState, (state: SessionState) => state && state.token);
export const selectIsAuthenticated = createSelector(selectAuthUserToken, (token: string | null) => !!token);
